import { ethAddressRegex, trxAddressRegex } from "./form";

/**
 * Типы поддерживаемых сетей кошельков
 */
export enum WALLET_NETWORK {
  ETH = "ETH",
  TRX = "TRX",
}

/**
 * Определяет к какой сети относится кошелек
 * @param walletAddress - адрес кошелька
 * @returns тип сети или null если не поддержтвается
 */
export const detectWalletNetwork = (walletAddress: string): WALLET_NETWORK | null => {
  if (!walletAddress || typeof walletAddress !== "string") {
    return null;
  }

  const trimmedAddress = walletAddress.trim();

  if (ethAddressRegex.test(trimmedAddress)) {
    return WALLET_NETWORK.ETH;
  }

  if (trxAddressRegex.test(trimmedAddress)) {
    return WALLET_NETWORK.TRX;
  }

  return null;
};

/**
 * Проверяет является ли адрес кошелька валидным для сети
 * @param networkType - тип сети
 * @param walletAddress - адрес кошелька
 * @returns true если адрес валидный, false если нет
 */
export const isValidNetworkAddress = (networkType: WALLET_NETWORK, walletAddress: string) => {
  if (!walletAddress) return false;
  if (networkType === WALLET_NETWORK.ETH) {
    return ethAddressRegex.test(walletAddress);
  }
  if (networkType === WALLET_NETWORK.TRX) {
    return trxAddressRegex.test(walletAddress);
  }
  return false;
};
